(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["complementarios"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bruder-complementarios')) {
    customElements.define(
      'bruder-complementarios',
      class extends HTMLElement {
        connectedCallback() {
          this.load();
        }

        esc(str) {
          const d = document.createElement('div');
          d.textContent = str ?? '';
          return d.innerHTML;
        }

        money(cents) {
          return new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: this.dataset.currency || 'MXN',
          }).format(cents / 100);
        }

        img(src) {
          if (!src) return '';
          try {
            const u = new URL(src, window.location.origin);
            u.searchParams.set('width', '160');
            return u.toString();
          } catch (e) {
            return src;
          }
        }

        priceHtml(v) {
          const compare =
            v.compare_at_price && v.compare_at_price > v.price
              ? `<s>${this.money(v.compare_at_price)}</s>`
              : '';
          return `${this.money(v.price)}${compare}`;
        }

        variantImage(p, v) {
          return (v && v.featured_image && v.featured_image.src) || p.featured_image;
        }

        item(p) {
          const variant = p.variants.find((v) => v.available) || p.variants[0];
          const multi = p.variants.length > 1;

          const select = multi
            ? `<select class="cmp__select" aria-label="Opción de ${this.esc(p.title)}">
                ${p.variants
                  .map(
                    (v) =>
                      `<option value="${v.id}"${v.id === variant.id ? ' selected' : ''}${
                        v.available ? '' : ' disabled'
                      }>${this.esc(v.title)}${v.available ? '' : ' (agotado)'}</option>`
                  )
                  .join('')}
              </select>`
            : '';

          return `
            <li class="cmp__item" data-product-id="${p.id}">
              <a class="cmp__img" href="${p.url}" tabindex="-1" aria-hidden="true">
                <img src="${this.img(this.variantImage(p, variant))}" alt="" width="64" height="64" loading="lazy">
              </a>
              <div class="cmp__info">
                <a class="cmp__name" href="${p.url}">${this.esc(p.title)}</a>
                <div class="cmp__price">${this.priceHtml(variant)}</div>
                ${select}
              </div>
              <button type="button" class="cmp__btn" data-variant="${variant.id}"><span>Agregar</span></button>
            </li>`;
        }

        onVariantChange(select) {
          const li = select.closest('.cmp__item');
          const p = this.products.get(li.dataset.productId);
          const v = p && p.variants.find((x) => String(x.id) === select.value);
          if (!v) return;

          li.querySelector('.cmp__price').innerHTML = this.priceHtml(v);
          li.querySelector('.cmp__img img').src = this.img(this.variantImage(p, v));

          const btn = li.querySelector('.cmp__btn');
          btn.dataset.variant = v.id;
          btn.disabled = !v.available;
          btn.querySelector('span').textContent = v.available ? 'Agregar' : 'Agotado';
        }

        async load() {
          const { productId, limit, url } = this.dataset;
          const list = this.querySelector('.cmp__list');
          try {
            const res = await fetch(
              `${url}.json?product_id=${productId}&limit=${limit}&intent=complementary`
            );
            if (!res.ok) return;
            const { products = [] } = await res.json();
            const items = products.filter((p) => p.available);

            if (!items.length) {
              if (this.dataset.designMode) {
                list.innerHTML =
                  '<li class="cmp__empty">Este producto no tiene complementarios asignados en Search & Discovery. El bloque no se mostrará en la tienda.</li>';
                this.hidden = false;
              }
              return;
            }

            this.products = new Map(items.map((p) => [String(p.id), p]));
            list.innerHTML = items.map((p) => this.item(p)).join('');
            this.hidden = false;
            list.addEventListener('change', (e) => {
              if (e.target.matches('.cmp__select')) this.onVariantChange(e.target);
            });
            list.addEventListener('click', (e) => {
              const btn = e.target.closest('button[data-variant]');
              if (btn) this.add(btn);
            });
          } catch (err) {
            console.error('Complementarios:', err);
          }
        }

        async add(btn) {
          const label = btn.querySelector('span');
          btn.disabled = true;
          label.textContent = 'Agregando…';

          try {
            const res = await fetch(this.dataset.cartAdd, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }] }),
            });
            if (!res.ok) {
              const data = await res.json().catch(() => ({}));
              throw new Error(data.description || 'No se pudo agregar');
            }

            const cart = await (await fetch(this.dataset.cart)).json();

            // Avisar a Horizon para que refresque el carrito y el contador
            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  sourceId: 'complementarios',
                  data: { source: 'complementarios', itemCount: cart.item_count },
                },
              })
            );

            label.textContent = 'Agregado';

            if (this.dataset.openDrawer === 'true') {
              const drawer = document.querySelector('cart-drawer-component');
              if (drawer && typeof drawer.open === 'function') drawer.open();
            }
          } catch (err) {
            label.textContent = 'Sin stock';
            console.error('Complementarios:', err);
          } finally {
            setTimeout(() => {
              btn.disabled = false;
              label.textContent = 'Agregar';
            }, 2000);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mensualidades"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bruder-mensualidades')) {
    customElements.define(
      'bruder-mensualidades',
      class extends HTMLElement {
        connectedCallback() {
          try {
            this.cfg = JSON.parse(this.querySelector('[data-config]').textContent);
          } catch (e) {
            return;
          }

          // Evento de Horizon al cambiar de variante
          this.onVariant = (e) => {
            const d = e.detail || {};
            const v = d.resource || d.variant;
            if (v && v.id && this.cfg.variants[v.id] !== undefined) this.update(v.id);
          };

          // Respaldo: leer ?variant= de la URL después de cualquier cambio en el formulario
          this.onChange = () => {
            setTimeout(() => {
              const id = new URL(window.location.href).searchParams.get('variant');
              if (id && this.cfg.variants[id] !== undefined) this.update(id);
            }, 60);
          };

          document.addEventListener('variant:update', this.onVariant);
          document.addEventListener('change', this.onChange);
        }

        disconnectedCallback() {
          document.removeEventListener('variant:update', this.onVariant);
          document.removeEventListener('change', this.onChange);
        }

        money(cents) {
          const n = cents / 100;
          const fmt = (d) =>
            n.toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d });
          return this.cfg.format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
            if (key === 'amount_no_decimals') return fmt(0);
            if (key === 'amount_with_comma_separator')
              return fmt(2).replace(/,/g, '#').replace('.', ',').replace(/#/g, '.');
            return fmt(2);
          });
        }

        update(id) {
          const price = Number(this.cfg.variants[id]);
          const months = Number(this.dataset.months);
          const factor = Number(this.dataset.factor);
          const total = Math.round(price * factor);
          const monthly = Math.round(total / months);
          const below = price < Number(this.dataset.min);

          const m = this.querySelector('[data-monthly]');
          if (m) m.textContent = this.money(monthly);
          const t = this.querySelector('[data-total]');
          if (t) t.textContent = this.money(total);

          if (this.dataset.designMode) {
            const hint = this.querySelector('[data-hint]');
            if (hint) hint.hidden = !below;
          } else {
            this.hidden = below;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
